import { render } from "./NewVwTestTabPane.vue?vue&type=template&id=0371acba&scoped=true"
import script from "./NewVwTestTabPane.vue?vue&type=script&lang=js"
export * from "./NewVwTestTabPane.vue?vue&type=script&lang=js"

import "./NewVwTestTabPane.vue?vue&type=style&index=0&id=0371acba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0371acba"]])

export default __exports__